import { LogoMark, Wordmark } from "./Logo";
import { scrollToId, PHONE_DISPLAY, PHONE_TEL, EMAIL, waLink } from "../lib";

const LINKS = [
    { id: "legacy", label: "Legacy" },
    { id: "products", label: "Products" },
    { id: "capabilities", label: "Capabilities" },
    { id: "projects", label: "Where We Innovate" },
    { id: "frontlines", label: "Frontlines" },
    { id: "contact", label: "Contact" },
];

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-line bg-panel/30"
        >
            <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
                <div className="grid gap-12 md:grid-cols-3">
                    <div>
                        <div className="flex items-center gap-3">
                            <LogoMark size={40} />
                            <Wordmark />
                        </div>
                        <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-500">
                            Manufacturers of hospital beds, OT tables and OT
                            lights. Designers of Clean Room &amp; Modular
                            Operation Theatres and CSSD. Since 1986.
                        </p>
                    </div>

                    <div>
                        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                            Explore
                        </p>
                        <div className="mt-5 flex flex-col items-start gap-3">
                            {LINKS.map((l) => (
                                <button
                                    key={l.id}
                                    data-testid={`footer-link-${l.id}`}
                                    onClick={() => scrollToId(l.id)}
                                    className="text-sm text-slate-400 transition-colors hover:text-accent"
                                >
                                    {l.label}
                                </button>
                            ))}
                            <button
                                data-testid="footer-catalogue-link"
                                onClick={() =>
                                    window.dispatchEvent(
                                        new Event("ss:catalogue"),
                                    )
                                }
                                className="text-sm text-slate-400 transition-colors hover:text-accent"
                            >
                                Request Catalogue PDF
                            </button>
                        </div>
                    </div>

                    <div>
                        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                            Reach Us
                        </p>
                        <div className="mt-5 flex flex-col items-start gap-3 text-sm">
                            <a
                                data-testid="footer-phone-link"
                                href={PHONE_TEL}
                                className="text-slate-400 transition-colors hover:text-accent"
                            >
                                {PHONE_DISPLAY}
                            </a>
                            <a
                                data-testid="footer-email-link"
                                href={`mailto:${EMAIL}`}
                                className="text-slate-400 transition-colors hover:text-accent"
                            >
                                {EMAIL}
                            </a>
                            <a
                                data-testid="footer-whatsapp-link"
                                href={waLink(
                                    "Hello Science & Surgical, I'd like to enquire about your products.",
                                )}
                                target="_blank"
                                rel="noreferrer"
                                className="text-slate-400 transition-colors hover:text-wa"
                            >
                                WhatsApp — chat with our team
                            </a>
                            <span className="text-slate-400">
                                Head Office — 300, Roy Bahadur Road, Kolkata,
                                West Bengal - 700053
                            </span>
                        </div>
                    </div>
                </div>

                <div className="mt-14 flex flex-col gap-4 border-t border-line pt-7 sm:flex-row sm:items-center sm:justify-between">
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
                        © 1986–2026 Science &amp; Surgical. All rights
                        reserved.
                    </p>
                    <p
                        data-testid="footer-registration-line"
                        className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600"
                    >
                        GST 19ADRFS8199Q1ZF · PAN ADRFS8199Q · IEC ADRFS8199Q
                    </p>
                </div>
            </div>
        </footer>
    );
}
